import { render, staticRenderFns } from "./releasesPopup.vue?vue&type=template&id=56693eae&scoped=true"
import script from "./releasesPopup.vue?vue&type=script&lang=js"
export * from "./releasesPopup.vue?vue&type=script&lang=js"
import style0 from "./releasesPopup.vue?vue&type=style&index=0&id=56693eae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56693eae",
  null
  
)

export default component.exports